"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FudaoDefinition_1 = require("../FudaoDefinition");
const FudaoUser_1 = require("../FudaoUser");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class FudaoDto {
    constructor(fudaoDto) {
        this.id = "";
        this.version = FudaoDefinition_1.FudaoVersion;
        this.teacher = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this.student = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this.standardDuration = 0;
        this.extendDuration = 0;
        this.startTime = 0;
        this.endTime = 0;
        this.status = FudaoDefinition_1.Status.None;
        this.chatId = "";
        //public sessionIds: string[] = [];
        this.dataSession = FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION;
        this.extendedTimes = 0;
        this.passedTimeMilliSecond = 0;
        if (fudaoDto) {
            this.id = fudaoDto.id || this.id;
            this.version = fudaoDto.version || this.version;
            this.teacher = new FudaoUser_1.FudaoUser(fudaoDto.teacher) || this.teacher;
            this.student = new FudaoUser_1.FudaoUser(fudaoDto.student) || this.student;
            this.standardDuration = fudaoDto.standardDuration || 0;
            this.extendDuration = fudaoDto.extendDuration || 0;
            this.startTime = fudaoDto.startTime || this.startTime;
            this.endTime = fudaoDto.endTime || this.endTime;
            this.status = fudaoDto.status || this.status;
            this.chatId = fudaoDto.chatId || this.chatId;
            //this.sessionIds = fudaoDto.sessionIds ? fudaoDto.sessionIds.slice() : this.sessionIds;
            this.dataSession = fudaoDto.dataSession ? new FudaoDefinition_1.FudaoSession(fudaoDto.dataSession) : this.dataSession;
            this.extendedTimes = fudaoDto.extendedTimes || this.extendedTimes;
            this.passedTimeMilliSecond = fudaoDto.passedTimeMilliSecond || this.passedTimeMilliSecond;
        }
    }
    //public teacherCommentForm: TeacherCommentForm;
    //public studentRatingForm: StudentRatingForm;
    duration() {
        const duration = this.endTime - this.startTime;
        return duration >= 0 ? duration : 0;
    }
    toString() {
        return JSON.stringify(this);
    }
    isValid() { return !TypeScriptUtils_1.isNullOrEmpty(this.id); }
}
FudaoDto.INVALID_FUDAO_DTO = new FudaoDto();
exports.FudaoDto = FudaoDto;
//# sourceMappingURL=FudaoDto.js.map